import { DtoBase } from "../../DtoBase";
import { AccountType } from "../UserDto";
import { HashSet } from "DiscoveryEngine.TS/Utils";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";
import { DirectoryUserDto } from "./DirectoryUserDto";


export class DirectoryGroupDto extends DtoBase {

	private static readonly Default_AccountType = AccountType.Native;

	public AccountType: AccountType;
	public DomainName: string;
	public EphemeralId: string;
	public PermanentId: string;
	public Name: string;
	public Description: string;
	public MemberGroupIds: HashSet<string>;
	public MemberUserIds: HashSet<string>
	// Not Serialized
	public ParentGroups: HashSet<DirectoryGroupDto>;
	public MemberGroups: HashSet<DirectoryGroupDto>;
	public MemberUsers: HashSet<DirectoryUserDto>;

	constructor() {
		super();

		this.AccountType = DirectoryGroupDto.Default_AccountType;
		this.DomainName = "";
		this.EphemeralId = "";
		this.PermanentId = "";
		this.Name = "";
		this.Description = "";
		this.MemberGroupIds = new HashSet<string>();
		this.MemberUserIds = new HashSet<string>();
		this.ParentGroups = new HashSet<DirectoryGroupDto>();
		this.MemberGroups = new HashSet<DirectoryGroupDto>();
		this.MemberUsers = new HashSet<DirectoryUserDto>();
	}

	public get HasDomainName(): boolean {
		return !!this.DomainName;
	}

	public get HasEphemeralId(): boolean {
		return !!this.EphemeralId;
	}

	public get HasPermanentId(): boolean {
		return !!this.PermanentId;
	}

	public get HasName(): boolean {
		return !!this.Name;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public get HasMemberGroupIds(): boolean {
		return (!!this.MemberGroupIds && this.MemberGroupIds.Count > 0);
	}

	public get HasMemberUserIds(): boolean {
		return (!!this.MemberUserIds && this.MemberUserIds.Count > 0);
	}

	public get HasParentGroups(): boolean {
		return (!!this.ParentGroups && this.ParentGroups.Count > 0);
	}

	public get HasMemberGroups(): boolean {
		return (!!this.MemberGroups && this.MemberGroups.Count > 0);
	}

	public get HasMemberUsers(): boolean {
		return (!!this.MemberUsers && this.MemberUsers.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.directory_group = {};
		obj = obj.directory_group;

		super.Write(obj, context);

		if (this.AccountType !== DirectoryGroupDto.Default_AccountType)
			obj.account_type = AccountType[this.AccountType];

		if (this.HasDomainName)
			obj.domain_name = this.DomainName;

		if (this.HasEphemeralId)
			obj.ephemeral_id = this.EphemeralId;

		if (this.HasPermanentId)
			obj.permanent_id = this.PermanentId;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasMemberGroupIds) {
			obj.member_group_ids = [];
			ObjSerUtils.WriteStringValueCollection(obj.member_group_ids, this.MemberGroupIds, context);
		}

		if (this.HasMemberUserIds) {
			obj.member_user_ids = [];
			ObjSerUtils.WriteStringValueCollection(obj.member_user_ids, this.MemberUserIds, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.directory_group)
			throw new Error();
		obj = obj.directory_group;

		super.Read(obj, context);

		if (obj.account_type !== undefined)
			this.AccountType = AccountType[<string>obj.account_type];

		if (obj.domain_name !== undefined)
			this.DomainName = obj.domain_name;

		if (obj.ephemeral_id !== undefined)
			this.EphemeralId = obj.ephemeral_id;

		if (obj.permanent_id !== undefined)
			this.PermanentId = obj.permanent_id;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.member_group_ids !== undefined) {
			this.MemberGroupIds.Clear();
			ObjSerUtils.ReadStringValueCollection(obj.member_group_ids, this.MemberGroupIds, context);
		}

		if (obj.member_user_ids !== undefined) {
			this.MemberUserIds.Clear();
			ObjSerUtils.ReadStringValueCollection(obj.member_user_ids, this.MemberUserIds, context);
		}
	}

}